import autocomplete from 'autocompleter'
import React, { Component } from 'react'

import 'autocompleter/autocomplete.css'

export class Suggester extends Component {
  constructor(props) {
    super(props)
    this.id = 'auto_' + Math.random() * 100000
    this.autocomplete = undefined
  }

  componentDidMount() {
    let element = document.getElementById(this.id)
    this.autocomplete = autocomplete({
      input: element,
      fetch: this.props.fetch,
      preventSubmit: true,
      onSelect: (item) => {
        document.getElementById(this.id).value = ''
        this.props.onSelect(item)
      },
      render: (item, currentValue) => {
        const div = document.createElement('div')
        div.innerHTML = this.props.render(item, currentValue)
        return div
      },
    })
  }

  componentWillUnmount() {
    this.autocomplete.destroy()
  }

  render() {
    const props = this.props
    const controlledProps =
      props.value !== undefined
        ? { onChange: props.onChange, value: props.value }
        : {}

    return (
      <div>
        {props.label ? <label>{props.label}:</label> : ''}
        <input
          type="text"
          className="input"
          style={{ width: 300 }}
          id={this.id}
          placeholder={this.props.placeholder}
          {...controlledProps}
        />
      </div>
    )
  }
}
